import { inject } from 'mobx-react';
import * as React from 'react';

import { PageStore } from 'bernie-core';

import { AdvertisingStore } from 'stores/advertising-store';

interface MesoTriggerProps {
  advertising?: AdvertisingStore;
  pageName: string;
  page?: PageStore;
}

@inject('advertising', 'page')
export class MesoTrigger extends React.Component<MesoTriggerProps> {
  public componentDidMount() {
    this.props.advertising.trigger(this.getPageName());
  }

  public getPageName() {
    return this.props.page && this.props.page.pageId ? this.props.page.pageId.split(',')[0] : '';
  }

  public render() {
    return null;
  }
}
